import { http, HttpResponse } from 'msw';

import { Brand } from '../schemas/brand';
import { randomBrand } from './fixture/brand';

export const brandHandlers = (brand?: Brand) => [
  http.get('**/brand', () => HttpResponse.json({ brand: brand || randomBrand })),
];
